<template>
    <transition name="slide-fade">
        <div class="carousel-item"
            v-show="currentSlide === index" >

             <picture>
              <source :srcset="slide">
               <img :src="slide" :alt="`img-${index}`"/>
            </picture>
            <div class="bottom-header el">
              <div class="column1"><h3 class="slide-in-bottom">{{title}}</h3>
              <p class="slide-in-bottom">{{text}}</p> </div>
              <div class="column2">
                <a :href=link class="slide-in-bottom">Περισσότερα</a>
              </div>               
            </div>
            <div class="bottom-header en">
              <div class="column1"><h3 class="slide-in-bottom">{{titlen}}</h3>
              <p class="slide-in-bottom">{{texten}}</p></div>     
              <div class="column2"><a :href=linken class="slide-in-bottom">More</a>      </div>        
            </div>
        </div>
    </transition>
</template>
<script>

export default {
  props: ['slide', "currentSlide", "index","title","titlen","text", "texten","link","linken"],
  methods: {
    drag2(event){
     event.preventDefault();
    },
  },
  data: () => ({
    slidesm1: [
      "/wp-content/uploads/2023/11/herom.webp",
      "/wp-content/uploads/2023/11/heron-m.webp",
    ],
  }),
}

</script>

<style>
@font-face {
  font-family: "ZonaPro";
  src: url("./ZonaPro-Light.woff2") format("woff2");
}
.buttons-outline{
  display: flex;
}
.btn-outline {
  border: 2px solid black;
  background-color: white;
  color: black;
  padding: 14px 28px;
  font-size: 16px;
  cursor: pointer;
}

/* Green */
.color-outline {
  border-color: #04AA6D;
  color: green;
}

.color-outline:hover {
  background-color: #04AA6D;
  color: white;
}
.hero-header {
    box-shadow: -2px 2px 12px rgb(0 0 0 / 17%);
    backdrop-filter: blur(4px);
    border-radius: 20px;
    padding: 40px;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
.carousel-item img{
  width: 100% !important;
  max-height: 450px !important;
}
.carousel-inner,.carousel-item{
  height: 550px !important;
}
.bottom-header h3{
  font-weight: 500 !important;
  font-size: 22px !important;
  font-family: "ZonaPro" !important;
}
.bottom-header p{
  font-weight: 300 !important;
  font-size: 17px !important;
  font-family: "ZonaPro" !important;
}
.bottom-header a{
    font-family: "ZonaPro" !important;
    border-radius: 5px !important;
    box-shadow: -2px 2px 12px rgb(0 0 0 / 17%);
    padding: 15px 30px 15px 30px;
    color: RGBA(80,124,41,1);
    border: 1px solid #507c29 !important;
    text-decoration: none;
    color: #507c29 !important;
}
.bottom-header a:hover{
  background: #507c29 !important;
  color: #fff !important;
}
.bottom-header{
  align-items: center !important;
  color: black !important;
}
.en{
  display: none;
}
#app{
  padding-left: 525px !important;
  padding-right: 525px !important;
}
.bottom-header{
  display: flex !important;
}
.bottom-header .column1{
  width: 70% !important;
}
.bottom-header .column2{
  width: 30% !important;
}
.carousel-item img{
  border-radius: 10px !important;
}
#app .carousel-control{
  top:37% !important;
}
#app .carousel-control img{
  width: 30px !important;
  filter: invert(43%) sepia(18%) saturate(1494%) hue-rotate(49deg) brightness(93%) contrast(87%);
}
#app .left{
  left: 28% !important;
}
#app .right{
  right: 28% !important;
}
#app .bottom-header .column2{
  margin-top: 5px !important;
  display: flex;
  justify-content: flex-end;
}
#app {
  position: relative;
}
</style>